import { render, staticRenderFns } from "./wonder-player.vue?vue&type=template&id=3f24fc28&scoped=true"
import script from "./wonder-player.vue?vue&type=script&lang=js"
export * from "./wonder-player.vue?vue&type=script&lang=js"
import style0 from "./wonder-player.vue?vue&type=style&index=0&id=3f24fc28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f24fc28",
  null
  
)

export default component.exports